import React from 'react';
import './Pages/PagesCss/PrivacyPolicy.css';

const CookiePolicy = () => {
  return (
    <div className="privacy-policy">
      {/* Header Section */}
      <section className="policy-header">
        <div className="container">
          <div className="header-content">
            <h1>Cookie Policy</h1>
            <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            <p className="header-description">
              This Cookie Policy explains how noobtobull uses cookies and similar technologies 
              to recognize you when you visit our websites. It explains what these technologies 
              are and why we use them, as well as your rights to control our use of them.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="policy-content">
        <div className="container">
          <div className="policy-grid">
            {/* Table of Contents */}
            <aside className="table-of-contents">
              <h3>Table of Contents</h3>
              <nav>
                <ul>
                  <li><a href="#what-are-cookies">What Are Cookies?</a></li>
                  <li><a href="#how-we-use">How We Use Cookies</a></li>
                  <li><a href="#types-of-cookies">Types of Cookies We Use</a></li>
                  <li><a href="#third-party-cookies">Third-Party Cookies</a></li>
                  <li><a href="#cookie-duration">Cookie Duration</a></li>
                  <li><a href="#managing-cookies">Managing Cookies</a></li>
                  <li><a href="#specific-cookies">Specific Cookies We Use</a></li>
                  <li><a href="#updates">Policy Updates</a></li>
                  <li><a href="#contact">Contact Us</a></li>
                </ul>
              </nav>
            </aside>

            {/* Policy Sections */}
            <div className="policy-sections">
                <p>
  This Cookie Policy applies to all websites and subdomains operated by D-Tech Studios for noobtobull, including <a href="https://noobtobull.com" target="_blank" rel="noopener noreferrer">https://noobtobull.com</a> and <a href="https://blog.noobtobull.com" target="_blank" rel="noopener noreferrer">https://blog.noobtobull.com</a>.
</p>
              <section id="what-are-cookies" className="policy-section">
                <h2>1. What Are Cookies?</h2>
                <div className="section-content">
                  <p>
                    Cookies are small text files that are placed on your computer or mobile device 
                    when you visit our website. They are widely used to make websites work more 
                    efficiently and provide information to the website owners.
                  </p>
                  
                  <h3>1.1 How Cookies Work</h3>
                  <p>
                    When you visit our site, we may store cookies on your browser to collect information. 
                    This information might be about you, your preferences, or your device and is mostly 
                    used to make the site work as you expect it to.
                  </p>

                  <h3>1.2 Similar Technologies</h3>
                  <p>
                    In addition to cookies, we may use other similar technologies such as:
                  </p>
                  <ul>
                    <li><strong>Web beacons:</strong> Tiny graphics with a unique identifier</li>
                    <li><strong>Local Storage:</strong> Data stored in your browser</li>
                    <li><strong>Session Storage:</strong> Temporary data for your browsing session</li>
                    <li><strong>Pixels:</strong> Small code snippets that track user behavior</li>
                  </ul>
                </div>
              </section>

              <section id="how-we-use" className="policy-section">
                <h2>2. How We Use Cookies</h2>
                <div className="section-content">
                  <p>We use cookies for several important reasons:</p>
                  <ul>
                    <li>To provide essential functionality of our financial calculators</li>
                    <li>To remember your preferences and settings</li>
                    <li>To understand how visitors interact with our tools</li>
                    <li>To improve the performance and user experience</li>
                    <li>To deliver relevant content and advertisements</li>
                    <li>To protect the security of our website</li>
                  </ul>

                  <p>
      We use Google AdSense for personalized ads. Consent is managed according to GDPR (Europe) and CCPA (California) regulations.
    </p>

                  <div className="important-note">
                    <h4>Important Note</h4>
                    <p>
                      Our financial calculators process all sensitive data locally in your browser. 
                      No personal financial information is stored in cookies or transmitted to our servers.
                    </p>
                  </div>
                </div>
              </section>

              <section id="types-of-cookies" className="policy-section">
                <h2>3. Types of Cookies We Use</h2>
                <div className="section-content">
                  
                  <h3>3.1 Essential Cookies (Strictly Necessary)</h3>
                  <p>These cookies are necessary for the website to function and cannot be switched off.</p>
                  <ul>
                    <li><strong>Purpose:</strong> Security, basic functionality, load balancing</li>
                    <li><strong>Examples:</strong> Session management, security tokens</li>
                    <li><strong>Impact if disabled:</strong> Website may not function properly</li>
                  </ul>

                  <h3>3.2 Performance Cookies (Analytics)</h3>
                  <p>These cookies allow us to count visits and traffic sources to improve performance.</p>
                  <ul>
                    <li><strong>Purpose:</strong> Understand how visitors use our calculators</li>
                    <li><strong>Examples:</strong> Google Analytics cookies</li>
                    <li><strong>Data collected:</strong> Anonymous usage statistics</li>
                  </ul>

                  <h3>3.3 Functionality Cookies</h3>
                  <p>These cookies enable the website to provide enhanced functionality.</p>
                  <ul>
                    <li><strong>Purpose:</strong> Remember your preferences and choices</li>
                    <li><strong>Examples:</strong> Language settings, calculator preferences</li>
                    <li><strong>Impact if disabled:</strong> Loss of personalized features</li>
                  </ul>

                  <h3>3.4 Targeting/Advertising Cookies</h3>
                  <p>These cookies may be set through our site by our advertising partners.</p>
                  <ul>
                    <li><strong>Purpose:</strong> Build a profile of your interests</li>
                    <li><strong>Examples:</strong> Social media cookies, advertising network cookies</li>
                    <li><strong>Data collected:</strong> Browsing habits and interests</li>
                  </ul>
                </div>
              </section>

              <section id="third-party-cookies" className="policy-section">
                <h2>4. Third-Party Cookies</h2>
                <div className="section-content">
                  <p>
                    In addition to our own cookies, we may use various third-party cookies 
                    to report usage statistics and deliver advertisements.
                  </p>

                  <h3>4.1 Analytics Partners</h3>
                  <p>We use Google Analytics to understand how our website is used:</p>
                  <ul>
                    <li><strong>Provider:</strong> Google Analytics</li>
                    <li><strong>Purpose:</strong> Website analytics and performance monitoring</li>
                    <li><strong>Data:</strong> Anonymous usage data, traffic patterns</li>
                    <li><strong>Opt-out:</strong> <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out</a></li>
                  </ul>

                  <h3>4.2 Advertising Partners</h3>
                  <p>We may work with advertising partners to show relevant ads:</p>
                  <ul>
                    <li><strong>Purpose:</strong> Personalized advertising</li>
                    <li><strong>Data:</strong> Generalized interests, browsing behavior</li>
                    <li><strong>Control:</strong> You can manage preferences through ad settings</li>
                  </ul>

                  <h3>4.3 Social Media Cookies</h3>
                  <p>These cookies are set by social media services we've added to the site:</p>
                  <ul>
                    <li><strong>Examples:</strong> Facebook, Twitter, LinkedIn buttons</li>
                    <li><strong>Purpose:</strong> Social sharing, engagement tracking</li>
                  </ul>
                </div>
              </section>

              <section id="cookie-duration" className="policy-section">
                <h2>5. Cookie Duration</h2>
                <div className="section-content">
                  
                  <h3>5.1 Session Cookies</h3>
                  <p>
                    These temporary cookies remain in your browser until you leave our website. 
                    They are automatically deleted when you close your browser.
                  </p>

                  <h3>5.2 Persistent Cookies</h3>
                  <p>
                    These cookies remain on your device for a set period specified in the cookie. 
                    They are activated each time you visit the website that created that particular cookie.
                  </p>

                  <div className="duration-table">
                    <h4>Typical Cookie Lifespans:</h4>
                    <ul>
                      <li><strong>Session cookies:</strong> Until browser closure</li>
                      <li><strong>Preference cookies:</strong> Up to 1 year</li>
                      <li><strong>Analytics cookies:</strong> 2 years maximum</li>
                      <li><strong>Advertising cookies:</strong> Several months</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section id="managing-cookies" className="policy-section">
                <h2>6. Managing Your Cookie Preferences</h2>
                <div className="section-content">
                  <p>You have several options to control how cookies are used on our website:</p>

                  <h3>6.1 Browser Controls</h3>
                  <p>Most browsers allow you to control cookies through their settings:</p>
                  <ul>
                    <li>Delete all or specific cookies</li>
                    <li>Block third-party cookies</li>
                    <li>Block all cookies from specific sites</li>
                    <li>Block all cookies entirely</li>
                  </ul>

                  <h3>6.2 Browser-Specific Instructions</h3>
                  <ul>
                    <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
                    <li><a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
                    <li><a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
                    <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
                  </ul>

                  <h3>6.3 Do Not Track</h3>
                  <p>
                    Some browsers have a "Do Not Track" feature that lets you tell websites 
                    that you do not want to have your online activities tracked. Our website 
                    does not currently respond to "Do Not Track" signals.
                  </p>

                  <h3>6.4 Opt-out Tools</h3>
                  <p>Industry-wide opt-out tools:</p>
                  <ul>
                    <li><a href="http://optout.aboutads.info/" target="_blank" rel="noopener noreferrer">Digital Advertising Alliance</a></li>
                    <li><a href="http://www.youronlinechoices.com/" target="_blank" rel="noopener noreferrer">Your Online Choices (EU)</a></li>
                    <li><a href="https://www.networkadvertising.org/choices/" target="_blank" rel="noopener noreferrer">Network Advertising Initiative</a></li>
                  </ul>
                </div>
              </section>

              <section id="specific-cookies" className="policy-section">
                <h2>7. Specific Cookies We Use</h2>
                <div className="section-content">
                  <p>Below is a detailed list of the main cookies we use on our website:</p>

                  <div className="cookies-list">
                    <h3>Essential Cookies</h3>
                    <ul>
                      <li><strong>session_id:</strong> Maintains your session state</li>
                      <li><strong>csrf_token:</strong> Protects against cross-site request forgery</li>
                      <li><strong>consent_status:</strong> Remembers your cookie preferences</li>
                    </ul>

                    <h3>Performance Cookies</h3>
                    <ul>
                      <li><strong>_ga:</strong> Google Analytics - distinguishes users (2 years)</li>
                      <li><strong>_gid:</strong> Google Analytics - distinguishes users (24 hours)</li>
                      <li><strong>_gat:</strong> Google Analytics - throttles request rate (1 minute)</li>
                    </ul>

                    <h3>Functionality Cookies</h3>
                    <ul>
                      <li><strong>theme_preference:</strong> Remembers your theme choice (1 year)</li>
                      <li><strong>calculator_settings:</strong> Saves your calculator preferences (30 days)</li>
                      <li><strong>language:</strong> Stores your language preference (1 year)</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section id="updates" className="policy-section">
                <h2>8. Changes to This Cookie Policy</h2>
                <div className="section-content">
                  <p>
                    We may update this Cookie Policy from time to time to reflect changes in 
                    technology, legislation, or our data practices. We will notify you of any 
                    material changes by posting the new policy on this page and updating the 
                    "Last updated" date.
                  </p>
                  <p>
                    We encourage you to periodically review this Cookie Policy to stay 
                    informed about how we are using cookies.
                  </p>
                </div>
              </section>

              <section id="contact" className="policy-section">
                <h2>9. Contact Us</h2>
                <div className="section-content">
                  <p>If you have any questions about our use of cookies, please contact us:</p>
                  <div className="contact-info">
                    <div className="contact-item">
                      <strong>Email:</strong> privacy@noobtobull.com
                    </div>
                    <div className="contact-item">
                      <strong>Address:</strong> 2568 Madison Ave, League City, TX 77573
                    </div>
                    <div className="contact-item">
                      <strong>Subject:</strong> Cookie Policy Inquiry
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Actions */}
      <section className="policy-actions">
        <div className="container">
          <div className="actions-content">
            <h3>Cookie Preferences</h3>
            <p>You can manage your cookie preferences at any time through our preference center.</p>
            <div className="action-buttons">
              <a href="/PrivacyPolicy" className="btn btn-primary">
                View Privacy Policy
              </a>
              <a href="/Disclaimer" className="btn btn-secondary">View Disclaimer</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;